import { createApp } from 'vue'
import i18n from './i18n'
import { setupAntd } from './ant-design.js'


import App from './App.vue'
import router from './router'
import store from './store'
// import "./assets/common.less"
import "./assets/common.css"
import 'ant-design-vue/dist/reset.css';
import { register } from 'swiper/element/bundle'
import {IMG_PUBLIC_PATH,AIPRB_IMG_PATH,IMG_PUBLIC_PATH_QM,IMG_PATH} from './utils/constants.js'

const app = createApp(App)
setupAntd(app)
// 添加判断页面大小的方法
const getScreenType = () => {
    const width = window.innerWidth
    if (width <= 768) {
        return 'mobile'
    } else {
        return 'pc'
    }
}
register();
// 将方法添加为全局属性
app.config.globalProperties.$getScreenType = getScreenType

// 添加响应式屏幕类型监听
window.addEventListener('resize', () => {
  app.config.globalProperties.$screenType = getScreenType()
})

// 初始化屏幕类型
app.config.globalProperties.$screenType = getScreenType()
app.config.globalProperties.$IMG_PUBLIC_PATH = IMG_PUBLIC_PATH
app.config.globalProperties.$IMG_PUBLIC_PATH_QM = IMG_PUBLIC_PATH_QM
app.config.globalProperties.$AIPRB_IMG_PATH = AIPRB_IMG_PATH
app.config.globalProperties.$IMG_PATH = IMG_PATH
app.use(store)
app.use(router)
app.use(i18n)

app.mount('#app')

